module.exports = __webpack_public_path__ + "img/BIT_white29.a4616454.jpg";